<template>
    <transition name="fade">
        <div class="liga-card" @click.prevent="goToNatjecatelji">
            <div class="icon"></div>
            <div class="desc">
                <Loading :loadingState="ligaLoadingState">
                        <h4>{{ ligaName }}</h4>
                        <p><span>{{ ligaNatjecateljiCount }}</span> natjecatelja</p>

                    <template v-slot:error>
                        Broj natjecatelja nepoznat
                    </template>
                </Loading>
            </div>
        </div>
    </transition>
</template>

<script>
import Loading from '../common/Loading'
import LoadingState from '../../utils/loading/LoadingState'
export default {
    name: 'ligasingle',
    data () {
        return {
            ligaLoadingState: LoadingState.LOADING,
            ligaName: null,
            ligaNatjecateljiCount: 0
        }
    },
    props: {
        ligaId: null
    },
    components: {
        Loading
    },
    methods: {
        goToNatjecatelji () {
            this.$router.push(`/natjecatelji/${this.ligaId}`)
        }
    },
    async mounted () {
        if (this.ligaId) {
            try {
                let object = await this.$db.lige.getLigaNameAndNatjecateljiCount(this.ligaId)
                this.ligaName = object.nazivLige
                this.ligaNatjecateljiCount = object.count
                this.ligaLoadingState = LoadingState.SUCCESS
            } catch (error) {
                this.ligaLoadingState = LoadingState.ERROR
            }
        } else {
            this.ligaLoadingState = LoadingState.SUCCESS
        }
    }
}
</script>

<style lang="scss" scoped></style>
